// extracted by mini-css-extract-plugin
export default {"LoginContainer":"gSVsHgVn","LoginCenterText":"EIV5DcNI"};